import React, { type SyntheticEvent } from 'react';
import Button from '@atlaskit/button';
import RefreshIcon from '@atlaskit/icon/core/migration/refresh';
import type { SyncButtonProps } from './types.tsx';

export const SyncButton = ({ id, onClick, label }: SyncButtonProps) => {
	const onButtonClick = (event: SyntheticEvent) => {
		event.preventDefault();
		onClick(id);
	};

	return (
		<Button appearance="subtle-link" onClick={onButtonClick}>
			<RefreshIcon LEGACY_size="small" label={label} />
		</Button>
	);
};

export default SyncButton;
